<template>
  <div class="login bg-light">
    <div class="container">
      <div class="flex justify-center pt-20 h-[70vh] sm:items-center sm:pt-0">
        <div class="flex flex-col w-full max-w-[700px]">
          <h1>{{ $t('Přihlášení') }}</h1>
          <div>
            <form class="p-10 rounded-md bg-white" @submit.prevent="login">
              <AppTextInput
                v-model="email"
                class="mb-4"
                input-class="py-3"
                data-test-id="login-email"
                type="email"
                :placeholder="$t('Email')"
                required
              />
              <AppTextInput
                v-model="password"
                class="mb-4"
                input-class="py-3"
                data-test-id="login-password"
                type="password"
                :placeholder="$t('Heslo')"
                required
              />
              <div class="flex justify-end items-end flex-col">
                <LocaleLink :to="{ name: 'reset-password' }" class="text-right @lg:w-2/3 font-bold">
                  <span
                    v-html="
                      $t(
                        'V případě, že máte registraci ze starého webu Belles Fleurs, <span class=&quot;text-primary&quot;>klikněte zde a heslo si resetujte.</span>'
                      )
                    "
                  ></span>
                </LocaleLink>
              </div>
              <div class="flex flex-col-reverse md:flex-row gap-4 items-center mt-5 mb-3">
                <div class="flex flex-col md:flex-row gap-4">
                  <AppButton
                    class=""
                    severity="secondary"
                    size="small"
                    type="button"
                    :to="{ name: 'register' }"
                  >
                    {{ $t('Registrovat se') }}
                  </AppButton>
                  <AppButton
                    class=""
                    severity="secondary"
                    size="small"
                    type="button"
                    :to="{ name: 'reset-password', query: email ? { email } : undefined }"
                  >
                    {{ $t('Zapomenuté heslo') }}
                  </AppButton>
                </div>
                <AppButton class="md:ml-auto" type="submit" arrows="right" severity="primary">
                  {{ $t('Přihlásit se') }}
                </AppButton>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  name: 'login',
  loginPage: true,
  middleware: 'auth',
})

const { query } = useRoute()
const email: Ref = ref(query.email)
const password: Ref = ref(null)

const { t } = useI18n()
const { $auth } = useNuxtApp()
const { addWarningMessage } = useToastService()

const login = async () => {
  try {
    await $auth.login(email.value, password.value)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    if (e.statusCode === 422) {
      addWarningMessage(t('Nesprávné přihlašovací údaje'))
    } else {
      console.log(e)
    }
  }
}
</script>

<style scoped></style>
